import { render } from "./main-view.vue?vue&type=template&id=6690d276&ts=true"
import script from "./main-view.vue?vue&type=script&lang=ts"
export * from "./main-view.vue?vue&type=script&lang=ts"

import "./main-view.vue?vue&type=style&index=0&id=6690d276&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__